import React from "react";
import "./Testimonials.css";
import Avatar1 from "../../assets/avatar1.jpg";
import Avatar2 from "../../assets/avatar2.jpg";
import Avatar3 from "../../assets/avatar3.jpg";
import Avatar4 from "../../assets/avatar4.jpg";
import { AiOutlinePlus } from "react-icons/ai";

// import Swiper core and required modules
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useState } from "react";
import NewTestinonial from "./NewTestimonial";
import { useTranslation } from "react-i18next";
import i18n from "../../languages/i18n";

const ahmedReview = `Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quasi,
minima ab modi quaerat incidunt doloribus debitis voluptatum,
voluptates autem recusandae minus, voluptas blanditiis atque nostrum
dolorem dicta itaque. Laudantium, consequuntur.`;
const data = [
  {
    id: 0,
    avatar: Avatar1,
    name: "Mr Smith",
    title: "PDG",
    company: "Company",
    review: ahmedReview,
  },
  {
    id: 1,
    avatar: Avatar2,
    name: "Sonia",
    title: "Commercial Agnt",
    review: "Sonia " + ahmedReview,
  },
  {
    id: 2,
    avatar: Avatar3,
    name: "Iness",

    title: "Billing Agent",
    company: "Company",
    review: "Iness " + ahmedReview,
  },
  {
    id: 3,
    avatar: Avatar4,
    name: "Tarek",
    title: "Head of dep",
    company: "Company",
    review: "Tarek " + ahmedReview,
  },
];

const Testimonials = () => {
  const [showNewTesti, setShowNewTesti] = useState(false);
  const { t } = useTranslation();
  return (
    <section id="testimonials">
      <h5 className={i18n.language == "ar" && "arabicText"}>
        {t("testiSection.reviews_title")}
      </h5>
      <h2 className={i18n.language == "ar" && "arabicText"}>
        {t("testiSection.testi_title")}
      </h2>
      <div className="container testimonials_container">
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          navigation
          pagination
          spaceBetween={50}
          slidesPerView={1}
          onSlideChange={() => console.log("slide change")}
          onSwiper={(swiper) => console.log(swiper)}
          className="swiperContainer"
        >
          {data.map((item) => {
            return (
              <SwiperSlide>
                <article className="testimonial">
                  <div className="client_avatar">
                    <img src={item.avatar} alt="Avatar One" srcset="" />
                  </div>
                  <h5 className="client_name">{item.name}</h5>
                  <h3 className="client_name">
                    {item.title} , {item.company}
                  </h3>
                  <p className="client_review">{item.review}</p>
                </article>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div
          className="testimonialPlus-container"
          onClick={() => setShowNewTesti(true)}
        >
          <AiOutlinePlus className="testimonialIcon" />
        </div>
      </div>
      <NewTestinonial
        show={showNewTesti}
        handleClose={() => setShowNewTesti(false)}
      />
    </section>
  );
};

export default Testimonials;
